export const BASIC_ELEMENT_CLASSID = "egr.wcf.core:BasicElement";
